<template>
  <div class="main-container">
    <EditEvent />
  </div>
</template>

<script>
import EditEvent from "@/components/templates/EditEvent";

export default {
  components: { EditEvent },
};
</script>